import * as React from 'react';
import classNames from 'classnames';
import {WithI18nProps, withI18n} from '@shopify/react-i18n';
import {User} from 'interfaces';
import {Button, Currency, Flex} from 'components/UIKit';
import * as locales from '../../locales';
import {Shop} from '../../types';
import style from './listing-contact-footer.scss';

export interface ListingContactFooterProps {
  shop: Shop;
  user?: User;
  hide?: boolean;
}

export function ListingContactFooterComponent({
  shop,
  user,
  hide,
  i18n,
}: ListingContactFooterProps & WithI18nProps) {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      className={classNames(style.container, {[style.hide]: hide})}
    >
      <Currency value={shop.salePrice} display="bigger" emphasis />
      <Button url={user ? '#ContactForm' : '#login'} label={i18n.translate('contactSeller')} />
    </Flex>
  );
}

export const ListingContactFooter = withI18n({
  fallback: locales.en,
  id: 'Listing',
})(ListingContactFooterComponent);

export default ListingContactFooter;
